"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APISource = void 0;
var APISource;
(function (APISource) {
    APISource["CCP_GATEWAY"] = "ccp";
    APISource["APD_GATEWAY"] = "apd";
})(APISource || (exports.APISource = APISource = {}));
